import dayjs from "dayjs";

interface Params {
  date?: string | Date;
  type?: string;
}

// 날짜 형식
export const getDate = ({ date, type }: Params) => {
  return dayjs(date).format(type);
};
